'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  CONNECT: 'CONNECT',
  CLOSE: 'CLOSE',
  ERROR: 'ERROR',
  SERVER_ERROR: 'SERVER_ERROR',
  AUTH: 'AUTH',
  OPERATIONS: 'OPERATIONS',
  DESTROY: 'DESTROY'
};